require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./introduction-to-wfs.json") })
        }
      }, "path---introduction-to-wfs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---introduction-to-wfs!./.cache/json/introduction-to-wfs.json
// module id = 372
// module chunks = 231608221292675